module.exports = __webpack_public_path__ + "static/img/reddit-icon-detail.19b24a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/mobile/assets/images/partners/reddit-icon-detail.png
// module id = 0zcz
// module chunks = 46